import React from 'react'

export default function FundFinderFilterDropdown({
  filterType,
  filter,
  onChangeHandler,
  classList,
}) {
  const renderFilter = () => {
    return filterType.map((item) => {
      return (
        <option value={item} key={item}>
          {item}
        </option>
      )
    })
  }

  return (
    <div className={classList}>
      <select
        id={`fund-finder-${filter}-dropdown`}
        className={`Dropdown-menu fund-${filter}-dropdown`}
        onChange={(e) => onChangeHandler(e.target.value)}
      >
        <option value="all" key="all">
          All
        </option>
        {renderFilter()}
      </select>
    </div>
  )
}
